import React from 'react';
import classNames from 'classnames/bind';

import styles from './FormStep.css';
import Dot from './Dot';
import Line from './Line';

const cx = classNames.bind(styles);

const stepper = function(props) {
  const { steps, current } = props;
  const titleName = ['Download', 'Choose Type', 'Import', 'Result'];

  const progress = [];
  for (let i = 0; i < steps - 1; i++) {
    progress.push(
      <div key={titleName[i]}>
        <div className={styles['step-contain']}>
          <div className={styles['step-container']}>
            <Dot current={i === current - 1} active={i < current - 1} />
            <Line current active={i < current - 1} />
          </div>
        </div>
        <p className={getTextClassNames(i, current === steps)}>
          {' '}
          {titleName[i]}
        </p>
      </div>
    );
  }
  progress.push(
    <div key={titleName[titleName.length - 1]}>
      <div className={styles['step-contain']}>
        <div className={styles['step-container']}>
          <Dot current={current === steps} />
        </div>
      </div>
      <p
        className={
          getTextClassNames(titleName.length - 1, current === steps)
          // `${current === steps ? styles[`item-text${titleName.length - 1}`] + ' ' + styles['item-text-active'] : styles[`item-text${titleName.length - 1}`]}`}
        }
      >
        {' '}
        {titleName[titleName.length - 1]}
      </p>
    </div>
  );

  return <div className={styles.progressSteps}>{progress}</div>;
};

const getTextClassNames = (index, active) => {
  return cx({
    'item-text0': index === 0,
    'item-text1': index === 1,
    'item-text2': index === 2,
    'item-text3': index === 3,
    'item-text-active': active,
  });
};

export default stepper;
